const validate = values => {
  const errors = {}

  if (!values?.bookings || values?.bookings.length === 0) {
    errors.bookings = "You must check at least one booking type!"
  }

  return errors
}

export default validate
